const devEmails = [
  'author@ipipal.com', 
  'skasi@ipipal.com', 
  'jaibharathi1991@gmail.com',
  'lokeshwaran768@gmail.com'
]

//Production
export default {
  health_backend_local: 'https://api.cuedlink.com/',
  health_backend: 'https://api.cuedlink.com/',
  backend: 'https://beta.cuetree.com/',
  infant_backend: 'https://api.cuedlink.com/infant/',
  socket:'wss://api.cuedlink.com',
  youtube_url:'https://www.youtube.com/embed/',
  file_url:'https://api.cuedlink.com/file?url=',
  profile_image_url:'https://cuedlink.s3.ap-south-1.amazonaws.com/uploads/user/profile_image/',
  s3_public:'https://selftree-public.s3.us-west-2.amazonaws.com/uploads/health_file_upload/',
  admin_emails:devEmails,
  google_sso:{
    client_id: "388443539886-6n7qfpqhmnthorg0o8mopu4c32lodlnh.apps.googleusercontent.com"
  },
  ecn_organization_id:"1465c358-fd69-429d-ac4c-974b0c6201fd"
}

//Test
/*export default {
  health_backend_local: 'https://demoapi.cuedlink.com/',
  health_backend: 'https://demoapi.cuedlink.com/',
  backend: 'https://beta.cuetree.com/',
  infant_backend: 'https://demoapi.cuedlink.com/infant/',
  socket:'wss://demoapi.cuedlink.com',
  youtube_url:'https://www.youtube.com/embed/',
  file_url:'https://demoapi.cuedlink.com/file?url=',
  profile_image_url:'https://cuedlink.s3.ap-south-1.amazonaws.com/uploads/user/profile_image/',
  s3_public:'https://selftree-public.s3.us-west-2.amazonaws.com/uploads/health_file_upload/',
  admin_emails:devEmails,
  google_sso:{
    client_id: "388443539886-6n7qfpqhmnthorg0o8mopu4c32lodlnh.apps.googleusercontent.com"
  },
  ecn_organization_id:"1465c358-fd69-429d-ac4c-974b0c6201fd"
  //google_sso:{
    //client_id: "313393603854-na39sfneapvb20ldg3qv5njuej3qnn5j.apps.googleusercontent.com"
  //}
}*/

//Local
/*export default {
  health_backend:'http://127.0.0.1:9000/',
  backend:'https://beta.cuetree.com/',
  infant_backend:'http://127.0.0.1:9000/infant/',
  socket:'ws://127.0.0.1:9000',
  file_url:'http://127.0.0.1:9000/file?url=',
  youtube_url:'https://www.youtube.com/embed/',
  profile_image_url:'https://cuedwell.s3.ap-south-1.amazonaws.com/uploads/user/profile_image/',
  s3_public:'https://selftree-public.s3.us-west-2.amazonaws.com/uploads/health_file_upload/',
  admin_emails:devEmails,
  google_sso:{
    client_id: "388443539886-6n7qfpqhmnthorg0o8mopu4c32lodlnh.apps.googleusercontent.com"
  }
}*/ 